import React from "react";
import HomeRoute from "./HomeRoute";


const UserRouter = () => {


    return (
        <>
            <HomeRoute/>
        </>
    );
}


export default UserRouter